import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  AspectRatio,
  Box,
  Container,
  Flex,
  GridItem,
  Text,
  VStack,
} from '@chakra-ui/react';
import Link from '@rsc/ui-components/tailwind/Link';
import { MdOpenInNew } from 'react-icons/md';
import DeptGrid from '../../../design-system/DeptGrid';
import CollectionSubMenu from './CollectionSubMenu';
import CollectionGallerySubMenu from './CollectionGallerySubMenu';
import DefaultSubMenu from './DefaultSubMenu';
import SanityBackgroundImage from '../../../atoms/SanityBackgroundImage';


export default function MobileMenu({ menuItems, menuOpen }) {
  const [subMenu, setSubMenu] = useState(null);

  const renderSubMenu = () => {
    if (subMenu.menuType === 'collection' && subMenu.isGallery === true) {
      return (
        <CollectionGallerySubMenu subMenu={subMenu} setSubMenu={setSubMenu} />
      );
    }

    if (subMenu.menuType === 'collection' && !subMenu.isGallery) {
      return <CollectionSubMenu subMenu={subMenu} setSubMenu={setSubMenu} />;
    }

    return <DefaultSubMenu subMenu={subMenu} setSubMenu={setSubMenu} />;
  };

  return (
    <VStack
      pos="fixed"
      w="100vw"
      h="100vh"
      bg="white"
      justify="flex-start"
      pt="112px"
      top={menuOpen ? 0 : '-100vh'}
      transition="top .3s ease-in-out"
      left="0"
      zIndex="998"
      display={{ base: 'flex', lg: 'none' }}
      pb="60px"
    >
      <Flex w="100vw" h="100%" pos="relative" overflow="hidden">
        <Container
          px="2"
          w="100%"
          h="100%"
          pos="absolute"
          left={subMenu ? '-100%' : '0vw'}
          transition="left .3s ease-in-out"
        >
          <DeptGrid w="100%" mt="4" columnGap="2">
            {menuItems?.length &&
              menuItems.filter(Boolean)?.map(item => {
                if (item.menuType === 'collection' && !item.isGallery) {
                  return (
                    <GridItem colSpan="3" mt="2" key={item.title} mb="6">
                      <Box pos="relative" onClick={() => setSubMenu(item)}>
                        <Text
                          textStyle="h3"
                          pos="absolute"
                          top="4"
                          w="100%"
                          px="4"
                          zIndex={1}
                          color="typography.lighter"
                          fontWeight="black"
                        >
                          {item.title}
                        </Text>
                        <AspectRatio ratio={1} w="100%">
                          <SanityBackgroundImage
                            w="100%"
                            h="100%"
                            borderRadius="lg"
                            gradientGenerator={url =>
                              `linear-gradient(180deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.00) 59.04%), url(${url}), lightgray -155.145px -1.208px / 194.193% 129.866% no-repeat;`
                            }
                            image={item.mobileImage}
                          />
                        </AspectRatio>
                      </Box>
                    </GridItem>
                  );
                }
                if (item.menuType === 'static') {
                  return (
                  <GridItem
                    colSpan="6"
                    key={item.title}
                    py="4"
                    mx="4"
                    borderBottom="1px #E2E5E9 solid"
                  >
                    <Text textStyle="body" fontWeight="bold">
                    <Link key={item.title} link={item?.link}>{item.title}
                    <MdOpenInNew size="24" className='ml-1 pl-1'/>
                    </Link>
                    </Text>
                  </GridItem>
              );
            }
                return (
                  <GridItem
                    colSpan="6"
                    key={item.title}
                    py="4"
                    mx="4"
                    borderBottom="1px #E2E5E9 solid"
                    onClick={() => setSubMenu(item)}
                  >
                    <Text textStyle="body" fontWeight="bold">
                      {item.title}
                    </Text>
                  </GridItem>
                );
              })}
          </DeptGrid>
        </Container>
        <Container
          px="6"
          w="100%"
          h="100%"
          pos="absolute"
          left={subMenu ? '0' : '100%'}
          transition="left .3s ease-in-out"
          overflowY="scroll"
          pb="10"
        >
          {menuOpen && subMenu && renderSubMenu()}
        </Container>
      </Flex>
    </VStack>
  );
}

MobileMenu.propTypes = {
  menuOpen: PropTypes.bool.isRequired,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      menuType: PropTypes.string.isRequired,
      isGallery: PropTypes.bool,
      mobileImage: PropTypes.shape({
        asset: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      }),
    })
  ).isRequired,
};
